/**
 * @generated SignedSource<<3ffa3ac436bed8266e1aa6d0fa65db88>>
 * @relayHash 4cfae0931b26b83ef93ac740f364c4ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e07aea790ec67791280e229850672a9c0fbe0b50827c6afacb9dfff48a3e5c38

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation$variables = {
  spaceId: string;
};
export type SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation$data = {
  readonly unwatchSpace: {
    readonly space: {
      readonly currentUser: {
        readonly isWatched: boolean;
      };
      readonly id: string | null | undefined;
    };
  } | null | undefined;
};
export type SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation = {
  response: SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation$data;
  variables: SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "currentUser",
            "value": true
          },
          {
            "kind": "Variable",
            "name": "spaceId",
            "variableName": "spaceId"
          }
        ],
        "kind": "ObjectValue",
        "name": "watchSpaceInput"
      }
    ],
    "concreteType": "WatchSpacePayload",
    "kind": "LinkedField",
    "name": "unwatchSpace",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isWatched"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4cfae0931b26b83ef93ac740f364c4ad",
    "id": "e07aea790ec67791280e229850672a9c0fbe0b50827c6afacb9dfff48a3e5c38",
    "metadata": {},
    "name": "SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation",
    "operationKind": "mutation",
    "text": "mutation SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation($spaceId:ID!){unwatchSpace(watchSpaceInput:{spaceId:$spaceId,currentUser:true}){space{id,currentUser{isWatched}}}}"
  }
};
})();

(node as any).hash = "a4f177be3ac1e0ec5d184466e2a6c9d3";

export default node;
